import { render, staticRenderFns } from "./SelectSeminarProblemCurriculumUnit.vue?vue&type=template&id=02060699&scoped=true&lang=pug&"
import script from "./SelectSeminarProblemCurriculumUnit.vue?vue&type=script&lang=ts&"
export * from "./SelectSeminarProblemCurriculumUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02060699",
  null
  
)

export default component.exports